"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashboardContext = void 0;
const react_1 = require("react");
const lodash_1 = require("lodash");
exports.DashboardContext = (0, react_1.createContext)({
    definitions: [],
    cardFactory: () => undefined,
    loadDashboard: () => [],
    saveDashboard: lodash_1.noop,
    openAddDialog: lodash_1.noop,
    remove: lodash_1.noop,
});
//# sourceMappingURL=dashboard-context.js.map